import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ECheckEstimationExistsActions } from '../../constants/actionTypes/checkEstimationExists';

export const checkEstimationExistsRequest = actionGenerator<
  ECheckEstimationExistsActions.CHECK_ESTIMATION_EXISTS_REQUEST
>(ECheckEstimationExistsActions.CHECK_ESTIMATION_EXISTS_REQUEST);

export const checkEstimationExistsRequestError = actionGenerator<
  ECheckEstimationExistsActions.CHECK_ESTIMATION_EXISTS_ERROR
>(ECheckEstimationExistsActions.CHECK_ESTIMATION_EXISTS_ERROR);

export const resetCheckEstimationExists = actionGenerator<ECheckEstimationExistsActions.RESET_CHECK_ESTIMATION_EXISTS>(
  ECheckEstimationExistsActions.RESET_CHECK_ESTIMATION_EXISTS,
);

export type TCheckEstimationExistsActions =
  | ReturnType<typeof checkEstimationExistsRequest>
  | ReturnType<typeof checkEstimationExistsRequestError>
  | ReturnType<typeof resetCheckEstimationExists>;
